var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isDevops && _vm.connected
    ? _c(
        "div",
        [
          _vm.inline
            ? [
                _vm.clinicName
                  ? _c(
                      "v-list",
                      {
                        staticClass: "devops-inline-nav py-0",
                        attrs: { nav: "", dense: "" },
                      },
                      [
                        _c(
                          "v-list-item",
                          {
                            staticClass: "devops-inline-item",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openDialog.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              { staticClass: "mr-2" },
                              [
                                _c("v-icon", { attrs: { color: "white" } }, [
                                  _vm._v("mdi-hospital-building"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              { staticClass: "ml-2" },
                              [
                                _c(
                                  "v-list-item-title",
                                  {
                                    staticClass:
                                      "devops-inline-title text-truncate",
                                  },
                                  [_vm._v(" " + _vm._s(_vm.clinicName) + " ")]
                                ),
                                _c(
                                  "v-list-item-subtitle",
                                  { staticClass: "devops-inline-subtitle" },
                                  [_vm._v(" " + _vm._s(_vm.clinicId) + " ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-list-item",
                          { staticClass: "devops-inline-item" },
                          [
                            _c(
                              "v-list-item-icon",
                              { staticClass: "mr-2" },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "offset-x": "",
                                      right: "",
                                      "nudge-right": "8",
                                      "close-on-content-click": false,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: { color: "white" },
                                                    },
                                                    "v-icon",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [_vm._v("mdi-toolbox")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      383696291
                                    ),
                                    model: {
                                      value: _vm.toolsMenuOpen,
                                      callback: function ($$v) {
                                        _vm.toolsMenuOpen = $$v
                                      },
                                      expression: "toolsMenuOpen",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list",
                                      {
                                        staticClass: "tools-menu py-1",
                                        attrs: { dense: "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "devops"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "teal",
                                                    },
                                                  },
                                                  [_vm._v("mdi-cog-play")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("devops-actions"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-subheader",
                                          {
                                            staticClass: "tools-section-header",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("tools-phone-related")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "telephony"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "cyan darken-1",
                                                    },
                                                  },
                                                  [_vm._v("mdi-phone-settings")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("telephony-panel")
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "emergency"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "red darken-1",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-map-marker-alert"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "emergency-address-compliance"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "twilioDebug"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "red darken-2",
                                                    },
                                                  },
                                                  [_vm._v("mdi-bug-outline")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("twilio-debug-panel")
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-subheader",
                                          {
                                            staticClass: "tools-section-header",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("tools-agent-related")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "agent"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "deep-purple",
                                                    },
                                                  },
                                                  [_vm._v("mdi-robot-outline")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("agent-panel"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog("erp")
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "teal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-database-sync-outline"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "erp-integration-panel"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "connector"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "success",
                                                    },
                                                  },
                                                  [_vm._v("mdi-connection")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "connector.panel-title"
                                                  )
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-subheader",
                                          {
                                            staticClass: "tools-section-header",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("tools-other")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog("api")
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "indigo",
                                                    },
                                                  },
                                                  [_vm._v("mdi-api")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("api-explorer"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "ticketing"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "deep-purple",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-clipboard-text-outline"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ticketing.title-menu")
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "invitation"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "amber darken-2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-ticket-confirmation-outline"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("invitation-code")
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "pitr"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "brown darken-1",
                                                    },
                                                  },
                                                  [_vm._v("mdi-history")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("pitr-title"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "admin"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "orange",
                                                    },
                                                  },
                                                  [_vm._v("mdi-shield-lock")]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("status-configuration")
                                                )
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.openToolDialog(
                                                  "system"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-list-item-icon",
                                              { staticClass: "mr-3" },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color:
                                                        "blue-grey darken-2",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "mdi-information-outline"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(_vm.$t("system-info"))
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              {
                                staticClass: "ml-2",
                                on: {
                                  click: function ($event) {
                                    _vm.toolsMenuOpen = !_vm.toolsMenuOpen
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-list-item-title",
                                  { staticClass: "devops-inline-title" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("devops-actions")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : [
                _vm.clinicName &&
                (!_vm.$vuetify.breakpoint.xs || _vm.mobileVisible)
                  ? _c(
                      "div",
                      {
                        staticClass: "indicator-wrap",
                        class: {
                          "mobile-top-center-wrap":
                            _vm.$vuetify.breakpoint.xs && _vm.mobileVisible,
                        },
                      },
                      [
                        _c("div", { staticClass: "devops-indicator" }, [
                          _c(
                            "div",
                            { staticClass: "indicator-content" },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "indicator-icon",
                                  attrs: { small: "" },
                                },
                                [_vm._v("mdi-hospital-building")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "clinic-details",
                                  on: { click: _vm.openDialog },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "clinic-name text-truncate",
                                    },
                                    [_vm._v(_vm._s(_vm.clinicName))]
                                  ),
                                  _c("span", { staticClass: "clinic-id" }, [
                                    _vm._v(_vm._s(_vm.clinicId)),
                                  ]),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "copy-indicator-btn",
                                  attrs: { icon: "", "x-small": "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.copyToClipboard(_vm.clinicId)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", { attrs: { "x-small": "" } }, [
                                    _vm._v("mdi-content-copy"),
                                  ]),
                                ],
                                1
                              ),
                              _c("v-divider", {
                                staticClass: "indicator-divider mx-1",
                                attrs: { vertical: "" },
                              }),
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    "offset-y": "",
                                    top: "",
                                    "nudge-top": "8",
                                    "close-on-content-click": false,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "actions-indicator-btn",
                                                    attrs: {
                                                      icon: "",
                                                      "x-small": "",
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { "x-small": "" } },
                                                  [_vm._v("mdi-toolbox")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    2103468934
                                  ),
                                  model: {
                                    value: _vm.toolsMenuOpen,
                                    callback: function ($$v) {
                                      _vm.toolsMenuOpen = $$v
                                    },
                                    expression: "toolsMenuOpen",
                                  },
                                },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "tools-menu py-1",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "devops"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "teal",
                                                  },
                                                },
                                                [_vm._v("mdi-cog-play")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("devops-actions"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-subheader",
                                        { staticClass: "tools-section-header" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tools-phone-related")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "telephony"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "cyan darken-1",
                                                  },
                                                },
                                                [_vm._v("mdi-phone-settings")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("telephony-panel"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "emergency"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "red darken-1",
                                                  },
                                                },
                                                [_vm._v("mdi-map-marker-alert")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "emergency-address-compliance"
                                                )
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "twilioDebug"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "red darken-2",
                                                  },
                                                },
                                                [_vm._v("mdi-bug-outline")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("twilio-debug-panel")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-subheader",
                                        { staticClass: "tools-section-header" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("tools-agent-related")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog("agent")
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "deep-purple",
                                                  },
                                                },
                                                [_vm._v("mdi-robot-outline")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("agent-panel"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog("erp")
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "teal",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-database-sync-outline"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("erp-integration-panel")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "connector"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "success",
                                                  },
                                                },
                                                [_vm._v("mdi-connection")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("connector.panel-title")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-subheader",
                                        { staticClass: "tools-section-header" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("tools-other")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog("api")
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "indigo",
                                                  },
                                                },
                                                [_vm._v("mdi-api")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("api-explorer"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "ticketing"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "deep-purple",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-clipboard-text-outline"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("ticketing.title-menu")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "invitation"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "amber darken-2",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-ticket-confirmation-outline"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("invitation-code"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog("pitr")
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "brown darken-1",
                                                  },
                                                },
                                                [_vm._v("mdi-history")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("pitr-title"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog("admin")
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "orange",
                                                  },
                                                },
                                                [_vm._v("mdi-shield-lock")]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("status-configuration")
                                              )
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.openToolDialog(
                                                "system"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-list-item-icon",
                                            { staticClass: "mr-3" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "blue-grey darken-2",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "mdi-information-outline"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("v-list-item-title", [
                                            _vm._v(
                                              _vm._s(_vm.$t("system-info"))
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-icon",
                                {
                                  staticClass: "chevron-icon",
                                  attrs: { small: "" },
                                  on: { click: _vm.openDialog },
                                },
                                [_vm._v("mdi-chevron-up")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "ticketing-pill-wrap" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "ticketing-pill",
                                attrs: {
                                  type: "button",
                                  title: _vm.$t("ticketing.title-menu"),
                                },
                                on: { click: _vm.onTicketingPillClick },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "white" } },
                                  [_vm._v("mdi-clipboard-text-outline")]
                                ),
                                _vm.unreadTicketingCount > 0
                                  ? _c(
                                      "span",
                                      { staticClass: "ticketing-badge" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.unreadTicketingCount) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "transition-group",
                                  {
                                    staticClass: "notif-toast-stack",
                                    attrs: { name: "notif-toast", tag: "div" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                      },
                                    },
                                  },
                                  _vm._l(_vm.notifToasts, function (t) {
                                    return _c(
                                      "div",
                                      {
                                        key: t.id,
                                        staticClass: "notif-toast",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openToastTicket(t)
                                          },
                                        },
                                      },
                                      [
                                        t.ticketTitle || t.organizationName
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "notif-toast__context",
                                              },
                                              [
                                                t.ticketTitle
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "notif-toast__row",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "notif-toast__emoji",
                                                          },
                                                          [_vm._v("🎟️")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "notif-toast__ticket text-truncate",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                t.ticketTitle
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                t.organizationName
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "notif-toast__row",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "notif-toast__emoji",
                                                          },
                                                          [_vm._v("🏢")]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "notif-toast__org text-truncate",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                t.organizationName
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "div",
                                          { staticClass: "notif-toast__msg" },
                                          [
                                            t.type === "ticket_updated" &&
                                            t.field
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          t.actorName ||
                                                            _vm.$t(
                                                              "ticketing.someone"
                                                            )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        " " +
                                                          _vm.$t(
                                                            "ticketing.activity-changed",
                                                            {
                                                              field: _vm.$t(
                                                                "ticketing.field." +
                                                                  t.field
                                                              ),
                                                            }
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                  t.fromValue != null &&
                                                  t.fromValue !== ""
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "grey--text text--lighten-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                " " +
                                                                  _vm.$t(
                                                                    "ticketing.activity-from"
                                                                  )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  t.fromValue != null &&
                                                  t.fromValue !== ""
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "notif-toast__value",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(t.fromValue)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "grey--text text--lighten-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            " " +
                                                              _vm.$t(
                                                                "ticketing.activity-to"
                                                              )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "notif-toast__value",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(t.toValue || "—")
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              : t.type === "attachments_added"
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          t.actorName ||
                                                            _vm.$t(
                                                              "ticketing.someone"
                                                            )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        " " +
                                                          _vm.$t(
                                                            "ticketing.activity-attachments-added"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "notif-toast__value",
                                                    },
                                                    [_vm._v(_vm._s(t.toValue))]
                                                  ),
                                                ]
                                              : t.type === "attachments_removed"
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          t.actorName ||
                                                            _vm.$t(
                                                              "ticketing.someone"
                                                            )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        " " +
                                                          _vm.$t(
                                                            "ticketing.activity-attachments-removed"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "notif-toast__value",
                                                    },
                                                    [_vm._v(_vm._s(t.toValue))]
                                                  ),
                                                ]
                                              : t.type === "watcher_added"
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          t.actorName ||
                                                            _vm.$t(
                                                              "ticketing.someone"
                                                            )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        " " +
                                                          _vm.$t(
                                                            "ticketing.activity-watcher-added"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "notif-toast__value",
                                                    },
                                                    [_vm._v(_vm._s(t.toValue))]
                                                  ),
                                                ]
                                              : t.type === "watcher_removed"
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-medium",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          t.actorName ||
                                                            _vm.$t(
                                                              "ticketing.someone"
                                                            )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        " " +
                                                          _vm.$t(
                                                            "ticketing.activity-watcher-removed"
                                                          )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "notif-toast__value",
                                                    },
                                                    [_vm._v(_vm._s(t.toValue))]
                                                  ),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(t.message) +
                                                      " "
                                                  ),
                                                ],
                                          ],
                                          2
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "close-on-content-click": false,
                                  "close-on-click": true,
                                  top: "",
                                  "offset-y": "",
                                  "nudge-top": 8,
                                  "min-width": "380",
                                  "max-width": "380",
                                  transition: "slide-y-reverse-transition",
                                  "position-x": _vm.notifMenuPositionX,
                                  "position-y": _vm.notifMenuPositionY,
                                  absolute: "",
                                },
                                model: {
                                  value: _vm.ticketingNotifMenuOpen,
                                  callback: function ($$v) {
                                    _vm.ticketingNotifMenuOpen = $$v
                                  },
                                  expression: "ticketingNotifMenuOpen",
                                },
                              },
                              [
                                _c("ticketing-notifications-panel", {
                                  attrs: {
                                    notifications: _vm.ticketingNotifications,
                                    "unread-count": _vm.unreadTicketingCount,
                                  },
                                  on: {
                                    "notification-click": _vm.onNotifPanelClick,
                                    "mark-all-read":
                                      _vm.onNotifPanelMarkAllRead,
                                    "clear-all": _vm.onNotifPanelClearAll,
                                    remove: _vm.onNotifPanelRemove,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "560",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-impersonate",
              },
              model: {
                value: _vm.dialogOpen,
                callback: function ($$v) {
                  _vm.dialogOpen = $$v
                },
                expression: "dialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-header" },
                    [
                      _c("div", { staticClass: "header-content" }, [
                        _c(
                          "div",
                          { staticClass: "header-icon-wrap" },
                          [
                            _c("v-icon", { staticClass: "header-icon" }, [
                              _vm._v("mdi-swap-horizontal-circle"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "header-text" }, [
                          _c("span", { staticClass: "header-title" }, [
                            _vm._v(_vm._s(_vm.$t("impersonate"))),
                          ]),
                          _c("span", { staticClass: "header-subtitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("select-organization") ||
                                  "Select an organization"
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "close-btn",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialogOpen = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "impersonate-content pa-0" },
                    [
                      _c(
                        "div",
                        { staticClass: "search-container" },
                        [
                          _c("v-text-field", {
                            ref: "searchField",
                            staticClass: "search-field",
                            attrs: {
                              placeholder: _vm.$t("search") + "...",
                              "prepend-inner-icon": "mdi-magnify",
                              clearable: "",
                              "hide-details": "",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.searchText,
                              callback: function ($$v) {
                                _vm.searchText = $$v
                              },
                              expression: "searchText",
                            },
                          }),
                          _vm.filteredOrganizations.length
                            ? _c("div", { staticClass: "results-count" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.filteredOrganizations.length) +
                                    " " +
                                    _vm._s(
                                      _vm.filteredOrganizations.length === 1
                                        ? "organization"
                                        : "organizations"
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.filteredOrganizations.length
                        ? _c(
                            "div",
                            { staticClass: "organization-list" },
                            [
                              _c("v-virtual-scroll", {
                                ref: "virtualScroll",
                                attrs: {
                                  items: _vm.filteredOrganizations,
                                  "item-height": 64,
                                  height: _vm.impersonateListHeight,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ item }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              class: [
                                                "org-list-item",
                                                {
                                                  "is-selected":
                                                    _vm.selected === item.id,
                                                },
                                              ],
                                              on: {
                                                click: function ($event) {
                                                  _vm.selected = item.id
                                                },
                                                dblclick: function ($event) {
                                                  item.id !== _vm.clinicId &&
                                                    _vm.impersonate(item.id)
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "org-avatar" },
                                                [
                                                  _vm.hasValidLogo(item)
                                                    ? _c("img", {
                                                        staticClass: "org-logo",
                                                        attrs: {
                                                          src: item.logo,
                                                          alt: _vm.organizationName(
                                                            item.name
                                                          ),
                                                        },
                                                        on: {
                                                          error: function (
                                                            $event
                                                          ) {
                                                            return _vm.onLogoError(
                                                              item.id
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getInitials(
                                                              _vm.organizationName(
                                                                item.name
                                                              )
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "org-info" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "org-name text-truncate",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.organizationName(
                                                            item.name
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    { staticClass: "org-id" },
                                                    [
                                                      _vm._v(
                                                        "ID: " + _vm._s(item.id)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "org-actions" },
                                                [
                                                  item.id === _vm.clinicId
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "current-chip",
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "primary",
                                                            "text-color":
                                                              "white",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "current"
                                                                ) || "Current"
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass:
                                                        "action-btn copy-btn",
                                                      attrs: {
                                                        icon: "",
                                                        small: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.copyToClipboard(
                                                            item.id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { small: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-content-copy"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  item.id !== _vm.clinicId
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          staticClass:
                                                            "action-btn switch-btn",
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.impersonate(
                                                                item.id
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-login-variant"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2183643700
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm.searchText
                        ? _c(
                            "div",
                            {
                              staticClass: "empty-state",
                              style: {
                                height: _vm.impersonateListHeight + "px",
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { large: "", color: "grey lighten-1" },
                                },
                                [_vm._v("mdi-magnify-close")]
                              ),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("no-results") ||
                                      "No organizations found"
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  _c("div", { staticClass: "dialog-footer" }, [
                    _c("div", { staticClass: "keyboard-hints" }, [
                      _c("span", { staticClass: "hint" }, [
                        _c("kbd", [_vm._v("↑↓")]),
                        _vm._v(" " + _vm._s(_vm.$t("navigate"))),
                      ]),
                      _c("span", { staticClass: "hint" }, [
                        _c("kbd", [_vm._v("Enter")]),
                        _vm._v(" " + _vm._s(_vm.$t("switch"))),
                      ]),
                      _c("span", { staticClass: "hint" }, [
                        _c("kbd", [_vm._v("Esc")]),
                        _vm._v(" " + _vm._s(_vm.$t("close"))),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "650",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-devops",
              },
              model: {
                value: _vm.actionsDialogOpen,
                callback: function ($$v) {
                  _vm.actionsDialogOpen = $$v
                },
                expression: "actionsDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-header devops-header" },
                    [
                      _c("div", { staticClass: "header-content" }, [
                        _c(
                          "div",
                          { staticClass: "header-icon-wrap" },
                          [
                            _c("v-icon", { staticClass: "header-icon" }, [
                              _vm._v("mdi-cog-play"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "header-text" }, [
                          _c("span", { staticClass: "header-title" }, [
                            _vm._v(_vm._s(_vm.$t("devops-actions"))),
                          ]),
                          _c("span", { staticClass: "header-subtitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.organizationName(_vm.clinicData?.name)
                              ) +
                                " (" +
                                _vm._s(_vm.clinicId) +
                                ")"
                            ),
                          ]),
                        ]),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "close-btn",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.actionsDialogOpen = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "tool-dialog-content pa-0" },
                    [
                      _c("devops-actions", {
                        ref: "devopsActions",
                        attrs: { embedded: "" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "900",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-telephony",
              },
              model: {
                value: _vm.telephonyDialogOpen,
                callback: function ($$v) {
                  _vm.telephonyDialogOpen = $$v
                },
                expression: "telephonyDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header telephony-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-phone-settings"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("telephony-panel"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "div",
                          { staticClass: "auto-refresh-indicator mr-3" },
                          [
                            _vm.telephonyRefreshError
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "refresh-error-icon",
                                    attrs: { small: "", color: "#ff5252" },
                                  },
                                  [_vm._v("mdi-close-circle")]
                                )
                              : _c("v-progress-circular", {
                                  staticClass: "auto-refresh-spinner",
                                  attrs: {
                                    indeterminate: "",
                                    size: "14",
                                    width: "2",
                                    color: "white",
                                  },
                                }),
                            _c(
                              "span",
                              {
                                staticClass: "auto-refresh-text",
                                class: {
                                  "refresh-text-error":
                                    _vm.telephonyRefreshError,
                                },
                              },
                              [
                                _vm.telephonySecondsAgo != null
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-ago", {
                                            seconds: _vm.telephonySecondsAgo,
                                          })
                                        )
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-every", {
                                            seconds: 5,
                                          })
                                        )
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.telephonyDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    {
                      staticClass:
                        "panel-dialog-content telephony-dialog-content pa-0",
                    },
                    [
                      _vm.telephonyDialogOpen
                        ? _c("telephony-panel", { ref: "telephonyPanel" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "650",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-admin",
                scrollable: "",
              },
              model: {
                value: _vm.adminDialogOpen,
                callback: function ($$v) {
                  _vm.adminDialogOpen = $$v
                },
                expression: "adminDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header admin-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-shield-lock"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("status-configuration"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.adminDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "admin-dialog-content pa-0" },
                    [
                      _vm.adminDialogOpen
                        ? _c("admin-form", {
                            ref: "adminForm",
                            on: { "status-updated": _vm.onStatusUpdated },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "750",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-agent",
              },
              model: {
                value: _vm.agentDialogOpen,
                callback: function ($$v) {
                  _vm.agentDialogOpen = $$v
                },
                expression: "agentDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header agent-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-robot-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("agent-panel"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "div",
                          { staticClass: "auto-refresh-indicator mr-3" },
                          [
                            _vm.agentRefreshError
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "refresh-error-icon",
                                    attrs: { small: "", color: "#ff5252" },
                                  },
                                  [_vm._v("mdi-close-circle")]
                                )
                              : _c("v-progress-circular", {
                                  staticClass: "auto-refresh-spinner",
                                  attrs: {
                                    indeterminate: "",
                                    size: "14",
                                    width: "2",
                                    color: "white",
                                  },
                                }),
                            _c(
                              "span",
                              {
                                staticClass: "auto-refresh-text",
                                class: {
                                  "refresh-text-error": _vm.agentRefreshError,
                                },
                              },
                              [
                                _vm.agentSecondsAgo != null
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-ago", {
                                            seconds: _vm.agentSecondsAgo,
                                          })
                                        )
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-every", {
                                            seconds: 5,
                                          })
                                        )
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.agentDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.agentDialogOpen
                        ? _c("agent-panel", { ref: "agentPanel" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "750",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-erp",
              },
              model: {
                value: _vm.erpDialogOpen,
                callback: function ($$v) {
                  _vm.erpDialogOpen = $$v
                },
                expression: "erpDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header erp-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-database-sync-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("erp-integration-panel"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "div",
                          { staticClass: "auto-refresh-indicator mr-3" },
                          [
                            _vm.erpRefreshError
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "refresh-error-icon",
                                    attrs: { small: "", color: "#ff5252" },
                                  },
                                  [_vm._v("mdi-close-circle")]
                                )
                              : _c("v-progress-circular", {
                                  staticClass: "auto-refresh-spinner",
                                  attrs: {
                                    indeterminate: "",
                                    size: "14",
                                    width: "2",
                                    color: "white",
                                  },
                                }),
                            _c(
                              "span",
                              {
                                staticClass: "auto-refresh-text",
                                class: {
                                  "refresh-text-error": _vm.erpRefreshError,
                                },
                              },
                              [
                                _vm.erpSecondsAgo != null
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-ago", {
                                            seconds: _vm.erpSecondsAgo,
                                          })
                                        )
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-every", {
                                            seconds: 5,
                                          })
                                        )
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.erpDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.erpDialogOpen
                        ? _c("erp-integration-panel", { ref: "erpPanel" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "750",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-connector",
              },
              model: {
                value: _vm.connectorDialogOpen,
                callback: function ($$v) {
                  _vm.connectorDialogOpen = $$v
                },
                expression: "connectorDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header connector-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-connection"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("connector.panel-title"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.connectorDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.connectorDialogOpen
                        ? _c("connector-panel", { ref: "connectorPanel" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "500",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-invitation",
              },
              model: {
                value: _vm.invitationDialogOpen,
                callback: function ($$v) {
                  _vm.invitationDialogOpen = $$v
                },
                expression: "invitationDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-header invitation-header" },
                    [
                      _c("div", { staticClass: "header-content" }, [
                        _c(
                          "div",
                          { staticClass: "header-icon-wrap" },
                          [
                            _c("v-icon", { staticClass: "header-icon" }, [
                              _vm._v("mdi-ticket-confirmation-outline"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "header-text" }, [
                          _c("span", { staticClass: "header-title" }, [
                            _vm._v(_vm._s(_vm.$t("invitation-code"))),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "header-actions" },
                        [
                          _c(
                            "div",
                            { staticClass: "auto-refresh-indicator mr-3" },
                            [
                              _vm.invitationRefreshError
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "refresh-error-icon",
                                      attrs: { small: "", color: "#ff5252" },
                                    },
                                    [_vm._v("mdi-close-circle")]
                                  )
                                : _c("v-progress-circular", {
                                    staticClass: "auto-refresh-spinner",
                                    attrs: {
                                      indeterminate: "",
                                      size: "14",
                                      width: "2",
                                      color: "white",
                                    },
                                  }),
                              _c(
                                "span",
                                {
                                  staticClass: "auto-refresh-text",
                                  class: {
                                    "refresh-text-error":
                                      _vm.invitationRefreshError,
                                  },
                                },
                                [
                                  _vm.invitationSecondsAgo != null
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("refresh-auto-ago", {
                                              seconds: _vm.invitationSecondsAgo,
                                            })
                                          )
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("refresh-auto-every", {
                                              seconds: 5,
                                            })
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "close-btn",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.invitationDialogOpen = false
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "tool-dialog-content pa-0" },
                    [
                      _vm.invitationDialogOpen
                        ? _c("invitation-code", { ref: "invitationCode" })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "750",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-system",
              },
              model: {
                value: _vm.systemDialogOpen,
                callback: function ($$v) {
                  _vm.systemDialogOpen = $$v
                },
                expression: "systemDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header system-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-information-outline"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("system-info"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "div",
                          { staticClass: "auto-refresh-indicator mr-3" },
                          [
                            _vm.systemRefreshError
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "refresh-error-icon",
                                    attrs: { small: "", color: "#ff5252" },
                                  },
                                  [_vm._v("mdi-close-circle")]
                                )
                              : _c("v-progress-circular", {
                                  staticClass: "auto-refresh-spinner",
                                  attrs: {
                                    indeterminate: "",
                                    size: "14",
                                    width: "2",
                                    color: "white",
                                  },
                                }),
                            _c(
                              "span",
                              {
                                staticClass: "auto-refresh-text",
                                class: {
                                  "refresh-text-error": _vm.systemRefreshError,
                                },
                              },
                              [
                                _vm.systemSecondsAgo != null
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-ago", {
                                            seconds: _vm.systemSecondsAgo,
                                          })
                                        )
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-every", {
                                            seconds: 5,
                                          })
                                        )
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.systemDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.systemDialogOpen
                        ? _c("system-info", {
                            ref: "systemInfo",
                            attrs: { embedded: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "900",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-api",
              },
              model: {
                value: _vm.apiDialogOpen,
                callback: function ($$v) {
                  _vm.apiDialogOpen = $$v
                },
                expression: "apiDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header api-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-api"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("api-explorer"))),
                        ]),
                        _c("span", { staticClass: "header-subtitle" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("test-api-endpoints") ||
                                "Test API endpoints"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "div",
                          { staticClass: "auto-refresh-indicator mr-3" },
                          [
                            _vm.apiRefreshError
                              ? _c(
                                  "v-icon",
                                  {
                                    staticClass: "refresh-error-icon",
                                    attrs: { small: "", color: "#ff5252" },
                                  },
                                  [_vm._v("mdi-close-circle")]
                                )
                              : _c("v-progress-circular", {
                                  staticClass: "auto-refresh-spinner",
                                  attrs: {
                                    indeterminate: "",
                                    size: "14",
                                    width: "2",
                                    color: "white",
                                  },
                                }),
                            _c(
                              "span",
                              {
                                staticClass: "auto-refresh-text",
                                class: {
                                  "refresh-text-error": _vm.apiRefreshError,
                                },
                              },
                              [
                                _vm.apiSecondsAgo != null
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-ago", {
                                            seconds: _vm.apiSecondsAgo,
                                          })
                                        )
                                      ),
                                    ]
                                  : [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("refresh-auto-every", {
                                            seconds: 5,
                                          })
                                        )
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.apiDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.apiDialogOpen
                        ? _c("api-explorer", {
                            ref: "apiExplorer",
                            attrs: { embedded: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "850",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-emergency",
              },
              model: {
                value: _vm.emergencyDialogOpen,
                callback: function ($$v) {
                  _vm.emergencyDialogOpen = $$v
                },
                expression: "emergencyDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header emergency-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-map-marker-alert"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("emergency-address-compliance"))
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "refresh-btn mr-2",
                            attrs: { small: "", outlined: "", dark: "" },
                            on: {
                              click: function ($event) {
                                _vm.$refs.emergencyPanel?.fetchReport()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-refresh"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.emergencyDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.emergencyDialogOpen
                        ? _c("emergency-address-panel", {
                            ref: "emergencyPanel",
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "900",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-twilio-debug",
              },
              model: {
                value: _vm.twilioDebugDialogOpen,
                callback: function ($$v) {
                  _vm.twilioDebugDialogOpen = $$v
                },
                expression: "twilioDebugDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-header twilio-debug-header" },
                    [
                      _c("div", { staticClass: "header-content" }, [
                        _c(
                          "div",
                          { staticClass: "header-icon-wrap" },
                          [
                            _c("v-icon", { staticClass: "header-icon" }, [
                              _vm._v("mdi-bug-outline"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "header-text" }, [
                          _c("span", { staticClass: "header-title" }, [
                            _vm._v(_vm._s(_vm.$t("twilio-debug-panel"))),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "header-actions" },
                        [
                          _c(
                            "div",
                            { staticClass: "auto-refresh-indicator mr-3" },
                            [
                              _vm.twilioRefreshError
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "refresh-error-icon",
                                      attrs: { small: "", color: "#ff5252" },
                                    },
                                    [_vm._v("mdi-close-circle")]
                                  )
                                : _c("v-progress-circular", {
                                    staticClass: "auto-refresh-spinner",
                                    attrs: {
                                      indeterminate: "",
                                      size: "14",
                                      width: "2",
                                      color: "white",
                                    },
                                  }),
                              _c(
                                "span",
                                {
                                  staticClass: "auto-refresh-text",
                                  class: {
                                    "refresh-text-error":
                                      _vm.twilioRefreshError,
                                  },
                                },
                                [
                                  _vm.twilioSecondsAgo != null
                                    ? [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("refresh-auto-ago", {
                                              seconds: _vm.twilioSecondsAgo,
                                            })
                                          )
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("refresh-auto-every", {
                                              seconds: 5,
                                            })
                                          )
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "close-btn",
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.twilioDebugDialogOpen = false
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-close")])],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.twilioDebugDialogOpen
                        ? _c("twilio-debugging-panel", {
                            ref: "twilioDebugPanel",
                            attrs: { embedded: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "750",
                fullscreen: _vm.$vuetify.breakpoint.xs,
                persistent: _vm.$vuetify.breakpoint.xs,
                "content-class": "dialog-rounded dialog-pitr",
              },
              model: {
                value: _vm.pitrDialogOpen,
                callback: function ($$v) {
                  _vm.pitrDialogOpen = $$v
                },
                expression: "pitrDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c("div", { staticClass: "dialog-header pitr-header" }, [
                    _c("div", { staticClass: "header-content" }, [
                      _c(
                        "div",
                        { staticClass: "header-icon-wrap" },
                        [
                          _c("v-icon", { staticClass: "header-icon" }, [
                            _vm._v("mdi-history"),
                          ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "header-text" }, [
                        _c("span", { staticClass: "header-title" }, [
                          _vm._v(_vm._s(_vm.$t("pitr-title"))),
                        ]),
                        _c("span", { staticClass: "header-subtitle" }, [
                          _vm._v(_vm._s(_vm.$t("pitr-restore-subtitle"))),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "refresh-btn mr-2",
                            attrs: { small: "", outlined: "", dark: "" },
                            on: {
                              click: function ($event) {
                                _vm.$refs.pitrPanel?.fetchCollections()
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("mdi-refresh"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "close-btn",
                            attrs: { icon: "" },
                            on: {
                              click: function ($event) {
                                _vm.pitrDialogOpen = false
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.pitrDialogOpen
                        ? _c("pitr-panel", {
                            ref: "pitrPanel",
                            attrs: { embedded: "" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                fullscreen: "",
                persistent: "",
                "no-click-animation": "",
                transition: "dialog-bottom-transition",
                "content-class": "dialog-ticketing",
              },
              model: {
                value: _vm.ticketingDialogOpen,
                callback: function ($$v) {
                  _vm.ticketingDialogOpen = $$v
                },
                expression: "ticketingDialogOpen",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "dialog-card" },
                [
                  _c(
                    "div",
                    { staticClass: "dialog-header ticketing-header" },
                    [
                      _c("div", { staticClass: "header-content" }, [
                        _c(
                          "div",
                          { staticClass: "header-icon-wrap" },
                          [
                            _c("v-icon", { staticClass: "header-icon" }, [
                              _vm._v("mdi-clipboard-text-outline"),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "header-text" }, [
                          _c("span", { staticClass: "header-title" }, [
                            _vm._v(_vm._s(_vm.$t("ticketing.title-menu"))),
                          ]),
                          _c("span", { staticClass: "header-subtitle" }, [
                            _vm._v(_vm._s(_vm.$t("ticketing.subtitle"))),
                          ]),
                        ]),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "close-btn",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.ticketingDialogOpen = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "panel-dialog-content pa-0" },
                    [
                      _vm.ticketingDialogOpen
                        ? _c("ticketing", {
                            attrs: {
                              embedded: "",
                              "open-ticket-id": _vm.pendingTicketOpenId,
                              "open-ticket-tab": _vm.pendingTicketOpenTab,
                            },
                            on: { "ticket-opened": _vm.onTicketOpened },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }